import { Component, forwardRef } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { PromotionPriceComponent } from '../promotion-price/promotion-price.component';
import { MenuConditionComponent } from '../../menu/menu-condition/menu-condition.component';
import { PanelModule } from '../../../modules/panel.module';

@Component({
  selector: 'brt-promotion-item',
  standalone: true,
  imports: [PanelModule, PromotionPriceComponent, MenuConditionComponent],
  templateUrl: './promotion-item.component.html',
  styleUrl: './promotion-item.component.scss',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => PromotionItemComponent),
      multi: true
    }
  ]
})
export class PromotionItemComponent {
  constructor() { }

  value: any[];

  addItem() {
    this.value.push({ Conditions: [{}] });
    this.onChange(this.value);
  }
  removeItem(index: number) {
    this.value.splice(index, 1);
    this.onChange(this.value);
  }

  writeValue(value: any[]) { this.value = value || []; }
  registerOnChange(fn: any) { this.onChange = fn; }
  registerOnTouched(fn: any) { this.onTouched = fn; }
  onChange = (_: any[]) => { };
  onTouched = () => { };
}
